import type { StoreAbortController } from './index';

const controllers = new WeakSet<StoreAbortController>();

export const explicitUserCancellations = {
	mark(controller?: StoreAbortController): void {
		if (controller) {
			controllers.add(controller);
		}
	},
	has(controller: StoreAbortController): boolean {
		return controllers.has(controller);
	},
};
